import { gsap } from 'gsap';

const isPlaying = [];

const playVideo = (src, index) => {
    if (isPlaying[index]) {
        isPlaying[index] = false;
        src.pause();
        return;
    }

    isPlaying[index] = true;
    src.play();
};

const muteVideo = (src, btn) => {
    const icon = btn.querySelector('use');

    if (!src.muted) {
        src.muted = true;
        icon.setAttribute('xlink:href', '#icon-play-audio');
        return;
    }

    src.muted = false;
    icon.setAttribute('xlink:href', '#icon-mute-audio');
};

const init = () => {
    const videos = document.querySelectorAll('.js-video');
    if (videos.length === 0) return;

    [...videos].forEach((video, index) => {
        const src = video.querySelector('.js-video-src');
        const muteBtn = video.querySelector('.js-video-mute-btn');

        isPlaying.push(src.autoplay);

        muteBtn?.addEventListener('click', (event) => {
            event.stopPropagation();
            muteVideo(src, muteBtn);
        });

        video.addEventListener('click', () => {
            const button = video.querySelector('.js-video-btn');
            button.classList.remove('hidden');

            if (isPlaying[index]) {
                gsap.set(button, { autoAlpha: 1 });
                if (muteBtn) gsap.set(muteBtn, { autoAlpha: 0 });
            }

            if (!isPlaying[index]) {
                gsap.set(button, { autoAlpha: 0 });
                if (muteBtn) gsap.set(muteBtn, { autoAlpha: 1 });
            }

            playVideo(src, index);
        });
    });
};

export default init;
